module.exports = __webpack_public_path__ + "static/media/multiple.b41654a2.png";